/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalendarDay
 */
export interface CalendarDay {
    /**
     * 
     * @type {string}
     * @memberof CalendarDay
     */
    day: string;
}

/**
 * Check if a given object implements the CalendarDay interface.
 */
export function instanceOfCalendarDay(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "day" in value;

    return isInstance;
}

export function CalendarDayFromJSON(json: any): CalendarDay {
    return CalendarDayFromJSONTyped(json, false);
}

export function CalendarDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'day': json['day'],
    };
}

export function CalendarDayToJSON(value?: CalendarDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'day': value.day,
    };
}

